import Vue from 'vue';
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
  configure,
} from 'vee-validate';
import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
import store from '@/core/services/store/index';
import * as rules from 'vee-validate/dist/rules';
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});
extend('url', {
  validate(value) {
    if (value) {
      return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
        value
      );
    }

    return false;
  },
  message: 'آدرس وبسایت معتبر نیست',
});

extend('phone', {
  message: (field) => field + ' معتبر نیست',
  validate: (value) => value.match(new RegExp('^[0,9]{1}[0-9]{9,10}$')),
});

extend('postalCode', {
  message: (field) => field + ' معتبر نیست',
  validate: (value) => value.match(new RegExp('^[0-9]{10}$')),
});

import en from 'vee-validate/dist/locale/en.json';
import fa from 'vee-validate/dist/locale/fa.json';
localize({
  en,
  fa,
});
localize('fa');

configure({
  classes: {
    invalid: 'is-invalid',
  },
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
